import { useQuery } from '@tanstack/react-query';
import apiFetch from '@wordpress/api-fetch';
import { addQueryArgs } from '@wordpress/url';

/**
 * Fetch event
 * @returns {object}
 */
function useWPEvents({ filter }) {
	const { isPending, isError, data, error, refetch } = useQuery({
		queryKey: ['filter'],
		queryFn: async () => {
			/* Add the nonce as middleware. This automatically adds the `X-WP-Nonce` header to requests. */
			apiFetch.use(
				apiFetch.createNonceMiddleware(window.visitEduSettings.nonce)
			);

			const path = addQueryArgs('/wp/v2/events', {
				...(filter.categories && { event_category: filter.categories }),
				...(filter.statuses && { event_status: filter.statuses }),
				per_page: 100,
				orderby: 'title',
				order: 'asc',
			});

			const response = await apiFetch({
				path: path,
				parse: false,
			});

			return await response.json();
		},
	});

	return {
		data,
		error,
		isError,
		isPending,
		refetch,
	};
}

export { useWPEvents };
